import JobWorkerInterviewContactDeclinedReason from "@/models/JobWorkerInterviews/JobWorkerInterviewContactDeclinedReason";

export default (reason: JobWorkerInterviewContactDeclinedReason) => {
    let returnVal = "Undefined"
    switch (reason) {
        case JobWorkerInterviewContactDeclinedReason.NoLongerInterested:
            returnVal = "No longer interested in this position";
            break;
        case JobWorkerInterviewContactDeclinedReason.Unavailable:
            returnVal = "Unavailable at this time";
            break;
        default:
            returnVal = "Undefined";
            break;
    }
    return returnVal;
}